export default __webpack_public_path__ + "static/media/connection-bg.55340153.png";